import GroupIcon from './group.svg';
import CoursesIcon from './courses.svg';
import DasboardIcon from './dashboard.svg';
import GradesIcon from './grades.svg';
import ReportsIcon from './reports.svg';
import SettingsIcon from './settings.svg';
import ExitIcon from './exit-left.svg';
import StudyIcon from './study.svg';
import SpacesIcon from './spaces.svg';
import ProfileIcon from './circle-user-round.svg';
import AdminReportsIcon from './reports-admin.svg';
import AdminSystemSetupIcon from './system-setup.svg';
import StudentDirectoryIcon from './student-directory.svg';
import AssistivFlowIcon from './assistiv-flow.svg';
import GradesNewIcon from './grades-new.svg';

export {
  GroupIcon,
  DasboardIcon,
  CoursesIcon,
  ReportsIcon,
  SettingsIcon,
  GradesIcon,
  ExitIcon,
  StudyIcon,
  SpacesIcon,
  ProfileIcon,
  AdminReportsIcon,
  AdminSystemSetupIcon,
  StudentDirectoryIcon,
  AssistivFlowIcon,
  GradesNewIcon,
};
